console.log('loaded');
for (const [key, value] of Object.entries(document.querySelectorAll('.img-on-bg'))) {
    var col = value.closest('.wpb_column');
    if (col.classList.contains('col-12')) {
        col.before(value);
    }
}

